import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { PrompterReportService } from '../../services/prompter-report.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { AuthService } from '../../services/auth.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-create-prompter-report',
    templateUrl: './create-prompter-report.component.html',
    styleUrls: ['./create-prompter-report.component.css', '../../app.component.css']
})

export class CreatePrompterReportComponent implements OnInit, OnDestroy {

    reportForm: FormGroup;
    report: any;

    prompters = {};
    prompterInit: any;
    prompterText = '';

    projects = {};
    projectInit: any;
    projectText = '';

    pickadateParams = Utils.pickadateParams();
    pickatimeParams = Utils.pickatimeParams();

    geSubs: any;
    gpoSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private prompterReportService: PrompterReportService,
                private employeeService: EmployeeService,
                private productionOrderService: ProductionOrderService,
                private authService: AuthService) {
        this.loadPromptersAndProjectsAndShips();
    }

    ngOnInit() {
        this.reportForm = this.formBuilder.group({
            prompter: ['', Validators.required],
            project: ['', Validators.required],
            reportDate: ['', Validators.required],
            captureTime: ['', Validators.required]
        });
    }

    onSubmitReport() {
        this.report = this.saveReport();

        this.prompterReportService.postPrompterReport(this.report).then(res => {
            this.reportForm.reset();

            this.router.navigate(['/edt_prompter_report/', res]);
        });
    }

    saveReport() {
        const reportDate = Utils.convertDatefromISOStringtoObject(this.reportForm.get('reportDate').value);
        const currentDate = new Date();
        const userSession = this.authService.currentUser;

        const reportJson = {
            active: 1,
            captureTime: this.reportForm.get('captureTime').value,
            createdAt: currentDate,
            employeeId: this.prompters[this.reportForm.get('prompter').value],
            productionOrderId: this.projects[this.reportForm.get('project').value],
            reportDate:  reportDate,
            updatedAt: currentDate,
            captureUser: userSession['email']
        };

        return reportJson;
    }

    loadPromptersAndProjectsAndShips() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempPrompters => {
            const dataEmployee = {};

            for (const idx in tempPrompters) {
                let employeeDisplayValue = `${tempPrompters[idx].name} ${tempPrompters[idx].lastName} (${tempPrompters[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.prompters[employeeDisplayValue] = tempPrompters[idx].id$;
            }

            this.prompterInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.prompters[val]);
                }
            };
        });

        this.gpoSubs = this.productionOrderService.getProductionOrders().subscribe(tempProjects => {
            const dataProject = {};

            for (const idx in tempProjects) {
                dataProject[tempProjects[idx].name] = null;
                this.projects[tempProjects[idx].name] = tempProjects[idx].id$;
            }

            this.projectInit = {
                'data': dataProject,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.projects[val]);
                }
            };
        });
    }

    onBlurPrompter() {
        if (this.prompters[this.prompterText] === undefined) {
            this.prompterText = '';
        }
    }

    onBlurProject() {
        if (this.projects[this.projectText] === undefined) {
            this.projectText = '';
        }
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
        this.gpoSubs.unsubscribe();
    }

}
